import { useState } from 'react'
import { ChevronDown } from 'lucide-react'

const navigationItems = [
  { href: '/#como-funciona', label: 'C\u00f3mo funciona' },
  { href: '/#productos', label: 'Productos' },
  { href: '/#casos', label: 'Casos de uso' },
  { href: '/#arquitectura', label: 'Arquitectura' },
  { href: '/#faq', label: 'FAQ' }
]

export default function LandingMainHeader({ className = 'bg-slate-950/80', theme = 'dark' }) {
  const [mobileMenu, setMobileMenu] = useState(false)

  const isLight = theme === 'light'
  const brandTextClass = isLight ? 'text-slate-900' : 'text-white'
  const navLinkClass = isLight ? 'text-slate-700 hover:text-slate-950' : 'text-slate-300 hover:text-cyan-300'
  const loginClass = isLight
    ? 'border border-slate-300 text-slate-800 hover:bg-slate-900/5'
    : 'border border-cyan-400/40 text-cyan-200 hover:bg-cyan-400/10'
  const ctaClass = isLight
    ? 'bg-slate-900 text-white hover:bg-slate-800'
    : 'bg-gradient-to-r from-cyan-500 to-blue-500 hover:from-cyan-400 hover:to-blue-400 text-slate-950'
  const menuButtonClass = isLight ? 'border-slate-300 text-slate-900' : 'border-slate-700 text-slate-100'
  const mobilePanelClass = isLight ? 'border-slate-200/80 bg-[#f5f2ec]/95' : 'border-white/10 bg-slate-950/95'
  const mobileBrandClass = isLight ? 'text-slate-900' : 'text-slate-100'
  const mobileNavClass = isLight ? 'text-slate-700' : 'text-slate-300'
  const mobileLoginClass = isLight ? 'text-slate-800' : 'text-cyan-200'
  const mobileCtaClass = isLight ? 'text-slate-950' : 'text-cyan-300'

  return (
    <header className={`sticky top-0 z-40 border-b border-white/10 backdrop-blur-xl ${className}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-20 flex items-center justify-between gap-4">
        <a href="/#hero" className={`font-display text-xl tracking-tight whitespace-nowrap ${brandTextClass}`}>
          AppEmprendedor
        </a>

        <div className="hidden xl:flex items-center gap-6">
          {navigationItems.map((item) => (
            <a key={item.href} href={item.href} className={`text-sm transition-colors whitespace-nowrap ${navLinkClass}`}>
              {item.label}
            </a>
          ))}
        </div>

        <div className="hidden xl:flex items-center gap-3">
          <a
            href="/login"
            className={`px-4 py-2 rounded-xl text-sm font-medium transition-colors whitespace-nowrap ${loginClass}`}
          >
            Acceder a la suite de apps
          </a>
          <a
            href="/#cta"
            className={`px-5 py-2.5 rounded-xl text-sm font-semibold transition-all whitespace-nowrap ${ctaClass}`}
          >
            {'Solicita la revisi\u00f3n de tu idea'}
          </a>
        </div>

        <button
          type="button"
          className={`xl:hidden p-2 rounded-lg border ${menuButtonClass}`}
          onClick={() => setMobileMenu((prev) => !prev)}
          aria-label="Menu"
        >
          <ChevronDown className={`w-5 h-5 transition-transform ${mobileMenu ? 'rotate-180' : ''}`} />
        </button>
      </div>

      {mobileMenu && (
        <div className={`xl:hidden border-t px-4 pb-4 space-y-3 ${mobilePanelClass}`}>
          <a href="/#hero" className={`block text-sm pt-3 ${mobileBrandClass}`}>
            AppEmprendedor
          </a>
          {navigationItems.map((item) => (
            <a key={item.href} href={item.href} className={`block text-sm py-1 ${mobileNavClass}`}>
              {item.label}
            </a>
          ))}
          <a href="/login" className={`block text-sm py-2 ${mobileLoginClass}`}>
            Acceder a la suite de apps
          </a>
          <a href="/#cta" className={`block text-sm py-2 font-semibold ${mobileCtaClass}`}>
            {'Solicita la revisi\u00f3n de tu idea'}
          </a>
        </div>
      )}
    </header>
  )
}
